<template>
  <div class="container" ref="container">
    <div class="chart">
      <div
        class="gauge"
        :style="{ width: chartData.value + '%' }"
        :class="{
          high: chartData.value > 59,
          normal: chartData.value >= 41 && chartData.value <= 59,
          low: chartData.value < 41
        }"
        :uk-tooltip="`title: ${tooltip}; pos: top-left; cls: uk-active uk-width-auto;`"
      ></div>
      <div v-for="n of split" :key="n" class="bar"></div>
    </div>
    <div class="score">{{ chartData.value }}</div>
  </div>
</template>
<style lang="scss" scoped>
.container {
  width: 100%;
  justify-content: flex-start;
  display: flex;
}
.chart {
  flex: 1;
  height: 20px;
  border: 1px solid $instruction-color;
  position: relative;
  display: flex;
  padding: $spacing-minimum 0;
  border-right: none;
  div.bar:not(:last-child) {
    height: 20px;
    border-right: 1px dashed $instruction-color;
  }
}
.bar {
  flex: 1;
}
.score {
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 $spacing-minimum;
  flex: initial;
  border: 1px solid $instruction-color;
}
.gauge {
  position: absolute;
  height: 70%;
  z-index: 9;
  &.high {
    background-color: #1e88e5 !important;
  }
  &.normal {
    background-color: #bdbdbd !important;
  }
  &.low {
    background-color: #f48fb1 !important;
  }
}
</style>
<script lang="ts">
import {} from "d3-color";
import { Prop, Ref } from "vue-property-decorator";
import ChartMixin from "../../helpers/mixins/chart";
export default class GaugeChart extends ChartMixin {
  @Ref("container") readonly container!: HTMLElement;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop({ type: Object, required: true }) chartData: any;
  @Prop({ type: Number }) split = 5;
  @Prop({ type: String }) tooltip: string = "";
}
</script>
